import {TextEditor} from "./TextEditor.js";
import {Temp} from "../utils/Temp.js";
import autoresize from "../utils/autoresize.js";

export class TextAreaEditor extends TextEditor {
	constructor(parent, fieldPath, obj, member, widgetOptions) {
		super(parent, fieldPath, obj, member, widgetOptions);
	}

	makeWidget() {
		const w = Temp.textarea(this.options);
		if (this.options.autoresize) {
			window.setTimeout(()=> {
				autoresize(w);
			}, 200);
		}
		return w;
	}
}
